<template>
    <div class="order-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/person' }">个人中心</el-breadcrumb-item>
            <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="order-content">
            <h3>订单详情</h3>
            <h4>订单号：{{orderDetail.order_no}}</h4>
            <el-row class="order-infor">
                <el-col :span="4">
                    <el-image :src="product_info.image" alt="志愿卡" fit="cover"></el-image>
                </el-col>
                <el-col :span="20">
                    <el-row class="order-infor-title">{{product_info.title.indexOf('荔枝生涯') !== -1 ? website.name ? product_info.title.replace('荔枝生涯', website.name) : '荔枝生涯' : product_info.title }}</el-row>
                    <el-row class="order-infor-fee">¥{{product_info.price}}</el-row>
                </el-col>
            </el-row>
            <div class="order-pay-infor">
                <h4>订单信息</h4>
                <el-row class="order-pay-desc"><span>付款时间：</span>{{orderDetail.pay_time?orderDetail.pay_time:'--'}}</el-row>
                <el-row class="order-pay-desc"><span>支付方式：</span>{{orderDetail.pay_type == 'ali'?'支付宝支付':'微信支付'}}</el-row>
                <el-row class="order-pay-desc"><span>支付金额：</span>{{orderDetail.pay_price}}元</el-row>
                <el-row class="order-pay-desc"><span>优惠券：</span>{{orderDetail.coupon_price}}元</el-row>
                <el-row class="order-pay-desc"><span>开通账户：</span>{{orderDetail.user_mobile}}</el-row>
                <el-row class="order-pay-desc"><span>使用日期：</span>有效期至{{orderDetail.vip_end_time?orderDetail.vip_end_time:'--'}}</el-row>
            </div>
        </div>
        
    </div>
</template>

<script>
import {orderDetail} from '@/api/pay'
import { mapState } from 'vuex'
export default {
    data () {
        return {
            order_no: '',
            orderDetail: '',
            product_info: {
                title: ''
            }
        }
    },
    computed: {
        ...mapState({
            website: state => state.user.website
        })
    },
    created () {
        this.order_no = this.$route.params.order_no
        this.orderDetailHandler('1')
    },
    methods: {
        orderDetailHandler() {
            orderDetail(this.order_no).then(res => {
                this.orderDetail = res.data
                this.product_info = res.data.product_info
                this.product_info.image = 'https://gaokao.zmpajx.com/'+ this.product_info.image
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .order-content {
        @include gwidth;
        height: 625px;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10); 
        margin-top: 24px;
        padding: 24px;
        box-sizing: border-box;
        h3 {
            font-size: 24px;
            color: #2c2e33;
            font-weight: 500;
            margin: 0;
        }
        h4 {
            font-size: 20px;
            font-weight: 500;
            color: #ff7721;
            margin: 24px 0;
            padding-bottom: 16px;
            border-bottom: 1px solid #f0f2f5;
        }
        .order-infor {
            height: 146px;
            background: #f5f7fa;
            border-radius: 10px;
            padding: 20px;
            box-sizing: border-box;
            .el-col-20 {
                padding-left: 35px;
            }
            .el-image {
                width: 200px;
                height: 106px;
            }
            .order-infor-title,.order-infor-fee {
                font-size: 18px;
                font-weight: 600;
                color: #2c2e33;
                margin-top: 4px;
            }
            .order-infor-fee {
                margin-top: 40px;
                font-weight: 400;
            }
        }
        .order-pay-infor {
            h4 {
                color: #2c2e33;
                margin-top: 32px;
                font-weight: 600;
                margin-bottom: 26px;
            }
            .order-pay-desc {
                font-size: 16px;
                font-weight: 400;
                color: #2c2e33;
                margin-bottom: 19px;
                span {
                    color: #5e6166;
                }
            }
        }
    }
</style>